import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {Router} from "@angular/router"

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';

import { WidgetModalComponent } from "./modals/widget.modal.component";

@Component({
    templateUrl: './widgets.component.html',
    styleUrls: [ './widgets.component.scss' ],
})
export class WidgetsComponent {

  @ViewChild('widgetModal') 
  public widgetModal: WidgetModalComponent;

  public isLoading:boolean = true;

  public rows: any;
  public pager: any = {
    'total': 0, 
    'perPage': environment.itemsPerPage, 
    'page': 1
  };
  public batchActions = [
    { 
      name: 'Zmień nazwę', 
      type: 'icon', 
      icon: 'fa fa-edit', 
      action: (event) => { this.edit(event) } 
    },
    { 
      name: 'Edytuj', 
      type: 'icon', 
      icon: 'fa fa-th', 
      action: (event) => { this.grape(event) } 
    },
    { 
      name: 'Usuń', 
      type: 'icon', 
      icon: 'fa fa-remove', 
      action: (event) => { this.delete(event) } 
    },
  ];
  public columns:Array<any> = [
    {title: 'Nazwa', name: 'nazwa'},
    {title: 'Edit', name: 'batch_actions', actions: this.batchActions },
  ];

  public actions:Array<any> = [
    { title: 'Utwórz nowy', class: 'primary', action: () => this.widgetModal.show(false) }
  ];

  constructor(private http: HttpService, private router: Router) {
    this.loadRows({page: 1});
    this.rows = [];
  }


  public loadRows(event) {
    let page = event.page;
    page = page ? page : 1;

    this.isLoading = true;
    let offset = (page-1)*this.pager.perPage;
    this.http.get(environment.backendUrl+'api/template/list/'+offset+'/'+this.pager.perPage)
           .subscribe(
                data => {
                  this.rows = data.json().data;
                  this.pager.total = data.json().count;
                  this.isLoading = false;
                },
                error => setTimeout(this.loadRows, 5000)
           );

  }

  public delete(event) {
    let id = event.target.parentNode.getAttribute('id');
    this.isLoading = true;

    this.http.delete(environment.backendUrl+'api/template/'+id)
           .subscribe(
                data => {   
                  this.isLoading = false;
                  this.loadRows({ page: 1 })
                },
                error => setTimeout(this.loadRows, 5000)
           );
  }

  public refreshList(event) {
    this.loadRows(1)
  }

  public tableChanged(page = 1) {
    this.loadRows(page);
  }

  public grape(event) {
    let id = event.target.parentNode.getAttribute('id');
    this.router.navigate(['/grape/'+id])
  }

  public edit(event) {
    let id = event.target.parentNode.getAttribute('id');

    this.http
      .get(environment.backendUrl + 'api/template/'+id, '')
      .subscribe(res => {
        this.widgetModal.show(res.json());
      });
  }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/widgets/widgets.component.ts